/**CORE LIBRARIES IMPORT */
import React from "react";

/**DATA / HOOKS IMPORT */
import { exteriorPhoto } from "../data/venue";
import useSiteSettings from "../hooks/useSiteSettings";

/**
 * The exterior photograph, shown unaltered inside the template's
 * gradient-bordered `.img-wrapper` frame. `sizes` lets the browser pick
 * the right file for the slot it is shown in. With `slot`, an image uploaded
 * for that slot in the portal (Website Media) replaces it, in the same frame
 * and cropped to the exterior photo's proportions.
 */
const VenuePhoto = ({ sizes = "100vw", className = "", caption, slot }) => {
  const { media } = useSiteSettings();
  const custom = slot ? media?.[slot] : null;
  return (
    <figure className={`venue-photo ${className}`}>
      <div className="img-wrapper">
        {custom ? (
          <img
            className="venue-photo-custom"
            src={custom.src}
            alt={custom.alt}
            style={{ objectPosition: custom.position, aspectRatio: `${exteriorPhoto.width} / ${exteriorPhoto.height}` }}
            loading="lazy"
            decoding="async"
          />
        ) : (
          <img
            src={exteriorPhoto.src}
            srcSet={exteriorPhoto.srcSet}
            sizes={sizes}
            width={exteriorPhoto.width}
            height={exteriorPhoto.height}
            alt={exteriorPhoto.alt}
            loading="lazy"
            decoding="async"
          />
        )}
      </div>
      {caption && <figcaption className="section-text">{caption}</figcaption>}
    </figure>
  );
};

export default VenuePhoto;
